var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "pub-container home"
  }, [_c("FormBox", {
    attrs: {
      title: "住院减免"
    },
    on: {
      inspect: _vm.inspectBtn
    }
  }, [_c("el-form", {
    ref: "form",
    staticStyle: {
      width: "100%",
      "padding-right": "20px"
    },
    attrs: {
      model: _vm.data,
      "label-width": "100px",
      rules: _vm.rules
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "年龄",
      prop: "age"
    }
  }, [_c("el-input", {
    attrs: {
      placeholder: "请输入年龄"
    },
    model: {
      value: _vm.data.age,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "age", $$v);
      },
      expression: "data.age"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "住院清单",
      prop: "hospitalizationList"
    }
  }, [_c("van-uploader", {
    attrs: {
      "after-read": _vm.zyqdAfterReadAvatar
    },
    on: {
      delete: _vm.zyqdBeforeDelete
    },
    model: {
      value: _vm.data.hospitalizationList,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "hospitalizationList", $$v);
      },
      expression: "data.hospitalizationList"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "结算清单",
      prop: "settlementList"
    }
  }, [_c("van-uploader", {
    attrs: {
      "after-read": _vm.jsqdAfterReadAvatar
    },
    on: {
      delete: _vm.jsqdBeforeDelete
    },
    model: {
      value: _vm.data.settlementList,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "settlementList", $$v);
      },
      expression: "data.settlementList"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "医保外费用",
      prop: "medicalInsuranceOutside"
    }
  }, [_c("el-input-number", {
    attrs: {
      precision: 2,
      step: 0.1,
      placeholder: "请输入医保外费用"
    },
    model: {
      value: _vm.data.medicalInsuranceOutside,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "medicalInsuranceOutside", $$v);
      },
      expression: "data.medicalInsuranceOutside"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "在班外费用",
      prop: "reductionAmount"
    }
  }, [_c("el-input-number", {
    attrs: {
      precision: 2,
      step: 0.1,
      placeholder: "请输入在班外费用"
    },
    model: {
      value: _vm.data.reductionAmount,
      callback: function callback($$v) {
        _vm.$set(_vm.data, "reductionAmount", $$v);
      },
      expression: "data.reductionAmount"
    }
  })], 1)], 1), _c("div", {
    staticStyle: {
      margin: "16px",
      width: "100%",
      padding: "0 20px"
    }
  }, [_c("el-button", {
    staticStyle: {
      width: "100%"
    },
    attrs: {
      type: "primary",
      round: "",
      disabled: _vm.isIpt
    },
    on: {
      click: function click($event) {
        return _vm.onSubmit("form");
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };